import styled from "styled-components";
import { DescriptionCell } from "./CommonStyles";
import { CustomLabel } from "@mindmemobile/mm-shared-global";
import { LabelCell, MainOuterCard } from "./Layout.styles";

interface IStyleProps {
  bgColor?: string;
  width?: string;
  margin?: string;
  borderLeft?: any;
  border?: any;
  padding?: any;
  height?: string;
}

export const VariantWrapper = styled.div`
  width: 100%;
  .item-variant-table {
    max-width: 800px;
    width: 100%;
    border: none;
    th,
    td {
      padding: 8px 10px;
      font-weight: 600;
      font-size: 16px;
    }
    td {
      color: #999 !important;
      cursor: pointer;
      .selected,
      &.selected {
        color: #556bb8 !important;
      }
    }
    thead {
      background-color: #f8f8f8;
      border-radius: 4px;
      th {
        border-bottom: none;
        color: #555;
        font-weight: 400;
        font-size: 14px;
      }
    }
    &.variant-table-chckbx {
      margin-top: 20px;
      thead {
        width: 100%;
      }
      tbody {
        max-height: 150px;
        height: auto;
      }
      .variant-header {
        padding-left: 21px;
      }
      th,
      td {
        font-size: 14px;
        font-weight: 400;
        border-bottom: none !important;
        &:first-child {
          width: 210px;
        }
      }
      .styled-chkbox input {
        height: 18px;
        width: 18px;
        margin-right: 0px;
      }
      ${CustomLabel} {
        margin-bottom: 0px;
        font-size: 14px;
        font-weight: 400;
      }

      th {
        &.on-hand-col {
          text-align: center;
          width: 100px;
        }
      }
      td {
        &.on-hand-col {
          padding-right: 40px;
          text-align: right;
          width: 100px;
        }
      }
      .variant-price-col {
        text-align: right;
        padding-right: 40px;
      }
    }
  }
  .return-days-chkbox {
    input {
      height: 40px;
      width: 60px;
      border: 1px solid #aaa;
    }
    &.label-description-row {
      margin: 0px;
      flex-direction: row-reverse;
      gap: 10px;
      > div:last-child {
        flex: 0;
      }
    }
    ${LabelCell} {
      width: auto;
    }
  }
  .tracking-shipping-block {
    .label-description-row {
      /* margin: 0px; */
      gap: 10px;
      flex-direction: column;
      align-items: flex-start;
    }
  }
  .edit-variant-image {
    border-radius: 10px;
    background-color: #f8f8f8;
    border: none;
    margin-bottom: 20px;
    img {
      /* height: 170px; */
      width: 115px;
      border-radius: 10px;
      height: 100%;
      max-height: 170px;
    }
  }
  .modal-right-panel {
    ${MainOuterCard}:not(:last-child) {
      margin: 0px 0px 20px;
    }
    .multiple-media-variant {
      background-color: transparent;
      justify-content: center;
      &:first-child {
        height: 60px;
        min-width: 60px;
        max-width: 100px !important;
        img {
          height: auto;
          width: auto;
          max-width: 200px;
          min-width: 40px;
          max-height: 60px;
          object-fit: contain;
          height: 60px;
          min-width: 60px;
          max-width: 100px;
        }
      }
      &:not(:first-child) {
        height: 60px;
        min-width: 60px;
        max-width: 100px;
        img {
          height: auto;
          width: auto;
          max-width: 200px;
          min-width: 40px;
          max-height: 60px;
          object-fit: contain;
          height: 60px;
          min-width: 60px;
          max-width: 100px;
        }
      }
      .delete-hovered-icon {
        height: 20px !important;
        width: 20px !important;
      }
    }
  }

  &.new-seller-popup {
    th {
      font-size: 16px;
      font-weight: 600;
    }
    td {
      padding-left: 13px !important;
    }
    .merchant-delete-icon {
      height: 16px;
    }
  }
  .categories-table {
    table {
      margin-top: 30px !important;
    }
    td {
      &:first-child {
        padding-left: 12px !important;
      }
    }
    .plh-main-section {
      border: none !important;
      label.plh-label {
        font-size: 18px !important;
        line-height: 20px !important;
        margin: 20px auto 5px !important;
      }
      img.plh-main-icon {
        height: 70px !important;
        width: 70px !important;
        margin-top: 18px !important;
      }
    }
  }
  &.category-block.payment-details-block {
    padding: 0px 30px 5px;
    .settings-sub-header {
      margin: 10px 0px 30px !important;
      align-items: flex-start;
      i.fa-chevron-down {
        margin-top: 3px !important;
        /* margin-bottom: 3px !important; */
      }
      i.fa-chevron-right {
        margin-top: 5px !important;
        /* margin-bottom: 2px !important; */
      }
      .collapsed-header-icon {
        height: 22px;
        width: 32px;
      }
    }
  }
  &.beneficiary-block {
    .payment-detail-header {
      margin: 0px 0px 20px !important;
    }
  }
`;
export const ItemDetailLeftPanel = styled.div<IStyleProps>`
  width: ${(props) => props.width || "50%"};
  padding: 0px 25px 0px 0px;
  /* border-right: 1px solid #ddd; */
  .description-label {
    word-break: break-word;
  }
  div img.pay-set-edit-icon {
    margin-bottom: 2px !important;
  }
  .usd-grey {
    font-size: 16px;
    font-weight: 400;
    color: #aaa;
    margin-left: 10px;
  }
`;
export const ItemDetailMainWrapper = styled.div`
  width: 100%;
  border-radius: 4px;
  height: 100%;
  /* overflow-y: auto;
    padding-right: 20px; */
  &::-webkit-scrollbar {
    width: 0.4em;
    height: 0.4em;
    background: rgba(21, 40, 55, 0.3);
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    outline: 1px solid #ddd;
    background-color: rgba(21, 40, 55, 0.1);
    border-radius: 10px;
  }
  .label-description-row ${CustomLabel} {
    line-height: 22px;
  }
  .type-icon {
    height: 22px;
    width: 22px;
    margin-right: 10px;
  }
  .yes-no-icon {
    height: 16px;
    width: 18px;
    margin-right: 8px;
    margin-bottom: 3px;
  }
  .yes-no-circle {
    height: 20px;
    width: 20px;
    /* margin-right: 8px; */
    /* margin-bottom: 1px; */
  }
  .orange-semi-bold {
    font-weight: 600;
    color: #ff5900;
  }
  .sapphire-blue {
    color: #556bb8;
    cursor: pointer;
    margin-left: 5px;
  }
  .item-main-image {
    height: 150px;
    width: 270px;
    border-radius: 10px;
    object-fit: contain; // logo mindme image is stretched
    /* height: 100%;
        max-height: 170px; */
  }
  .media-selectors img {
    height: 60px;
    width: auto;
    /* min-width: 70px;   // As it makes the image stretched */
    /* max-width: 100px; */
  }
  .blue-dots {
    cursor: pointer;
    height: 18px;
    width: 18px;
  }
  .status-lh${CustomLabel} {
    line-height: 30px;
  }
  .settings-sub-header {
    gap: 15px;
    margin: 10px 0px 30px !important;
    &:not(:first-child) {
      margin-top: 40px !important;
    }
    label {
      font-size: 18px;
      font-weight: 400;
      color: #555;
    }
    i {
      &.fa-chevron-right {
        margin-top: 0px;
      }
    }
  }
  .detail-sub-panel {
    padding-left: 30px;
    &.pay-settings-sub-panel {
      width: 100%;
      &:not(:first-child) {
        margin-top: 40px;
      }
      .fa-chevron-right {
        margin-top: 4px;
        font-size: 14px;
      }
      .fa-chevron-down {
        margin-top: 2px;
        font-size: 14px;
      }
    }
  }
  &.merchant-account-wrapper {
    .label-description-row:not(.merchant-collapsible-panel) {
      margin-bottom: 30px;
    }
    .merchant-collapsible-panel {
      margin-bottom: 10px;
    }
  }

  &.payment-settings-wrapper {
    .ps-main-outer-card {
      width: 100%;
      min-width: 1022px;
    }
    .payment-detail-header {
      width: 100%;
      margin: 0px !important;
      display: flex;
      align-items: center;
      label {
        line-height: normal;
        font-size: 22px;
        font-weight: 600;
      }
      i {
        margin-left: 10px;
        margin-top: 1px;
        &.fa-chevron-right {
          margin-top: 5px;
        }
        &.fa-chevron-down {
        }
      }
    }
    .ps-left-margin {
      padding-left: 40px;
    }
    .beneficiary-block {
      .payment-detail-header {
        margin: 0px 0px 10px !important;
      }
    }

    div:not(.ps-general-sub-inputs) ${DescriptionCell} {
      .single-select-wrapper {
        width: 400px;
        .header {
          width: 400px;
        }
        .options-menu > div {
          max-height: 80px;
        }
      }

      .country-dropdown {
        width: 400px;
        > div {
          border: 1px solid #aaa;
          padding-left: 15px;
          height: 40px;
        }
        .custom-label {
          font-size: 16px;
          font-weight: 400;
        }
        .dropdown-toggle::after {
          font-size: 25px;
          color: #555;
          transform: translate(11px, 8px);
        }
        .dropdown-menu {
          transform: translate(-17px, 39px) !important;
          width: 402px;
          .dropdown-item {
            padding-left: 15px;
            color: #555;
          }
        }
      }
    }
    div.ps-general-sub-inputs {
      ${DescriptionCell} {
        .single-select-wrapper,
        .single-select-wrapper .header {
          width: 300px;
        }
      }
    }
    // .category-block {
    //     margin-top: 50px;
    // }
    .basic-table {
      th,
      td {
        &:first-child {
          padding-left: 0px;
        }
      }
    }
    .seller-table {
      td,
      th {
        &:first-child {
          padding-left: 0px !important;
          width: 10% !important;
        }
      }
      th {
        font-size: 16px;
        font-weight: 400;
      }
      .table-header-desc {
        font-size: 16px !important;
        font-weight: 400;
      }
      table {
        margin-top: 20px !important;
      }
    }
  }
  &.funding-detail-page {
    .table-header-max-height {
      thead {
        /* margin-bottom: 0px; */
        th {
          font-weight: 400;
          color: #555;
          padding-top: 3px;
          padding-bottom: 3px;
          &:first-child {
            padding-left: 0px;
          }
        }
      }
      .status-btn {
        width: 90px !important;
      }
      td {
        padding: 3px;
        border-bottom: none;
        &:first-child {
          padding-left: 0px !important;
        }
      }
    }
    .fee-funding-section {
      width: 200px;
      flex: unset;
      .collapsed-header-label {
        font-size: 16px;
        font-weight: 400;
      }
      i.fa.fa-regular {
        font-size: 12px;
        padding-left: 5px;
        margin-bottom: 2px;
      }
    }
  }
  .contact-payment-plh {
    height: 400px;
    .plh-main-section {
      border: none !important;
    }
    .plh-label {
      color: #555 !important;
    }
    .plh-main-icon {
      margin-top: 10px !important;
    }
  }
`;
export const ItemDetailRightPanel = styled.div<IStyleProps>`
  width: ${(props) => props.width || "50%"};
  padding: ${(props) => props.padding || "0px 25px"};
  border-left: ${(props) => props.borderLeft || "1px solid #ddd"};
  .inventory-select {
    width: 160px;
    .header {
      justify-content: flex-end;
      width: 160px;
    }
    .fa-caret-down {
      margin-bottom: 3px;
    }
    .select-header-span {
      width: auto;
      label {
        cursor: pointer;
      }
    }
    .options-menu {
      width: 123px;
      transform: translate(40px, 25px);
      li {
        text-align: right;
        padding-right: 15px;
      }
    }
    .select-header-icon {
      display: none;
    }
  }
  .on-hand-edit {
    height: 16px;
    width: 16px;
    cursor: pointer;
    margin-left: 5px;
    margin-bottom: 5px;
  }
  .gateway-col {
    align-items: center;
    label {
      margin-top: 12px;
    }
  }
`;
